import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'OnboardingV2Footnote',
  setup(__props) {

    /**
     * OnboardingV2Footnote
     *
     * A reusable footnote component for the Onboarding V2 experiment.
     * Provides consistent styling for footnote text with support for links.
     *
     * Usage:
     * <onboarding-v2-footnote>
     *     Some footnote text with a <a href="#">link</a>.
     * </onboarding-v2-footnote>
     */

return { __sfc: true, }
}

})